import { useState, useEffect, useCallback } from "react";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import OutlinedInput from "@mui/material/OutlinedInput";
import Box from "@mui/material/Box";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";

// Data
import tableData from "layouts/pages/users/facilities/data/tableData";
import FacilitiesAPI from "api/facilities";

function Facilities() {
  const { columns } = tableData;
  const [facilitiesList, setFacilitiesList] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    Customer_Name: "",
    Primary_Key: "",
    Facility: "",
    State: "",
    Legacy: ""
  });

  const fetchFacilities = useCallback(async () => {
    try {
      const response = await FacilitiesAPI.ListFacilities();
      if (response.data && response.data.length) {
        const formatted = response.data.map((facility, index) => ({
          id: index + 1,
          Customer_Name: facility.Customer_Name || '',
          Primary_Key: facility.Primary_Key || '',
          Facility: facility.Facility || '',
          State: facility.State || '',
        }));
        setFacilitiesList(formatted);
      }
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  }, []);

  useEffect(() => {
    fetchFacilities();
  }, [fetchFacilities]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await FacilitiesAPI.CreateFacility(formData);
      await fetchFacilities();
      handleClose();
      setFormData({
        Customer_Name: "",
        Primary_Key: "",
        Facility: "",
        State: "",
        Legacy: ""
      });
    } catch (err) {
      console.error("Failed to create facility", err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <SoftBox>
            <SoftButton onClick={handleOpen} color="dark">
              + Create Facility
            </SoftButton>
          </SoftBox>
        </SoftBox>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Table columns={columns} rows={facilitiesList} />
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />

      {/* Modal for new facility */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {["Customer_Name", "Primary_Key", "Facility", "State", "Legacy"].map((field) => (
                <Grid item xs={12} key={field}>
                  <OutlinedInput
                    fullWidth
                    placeholder={field.replace("_", " ")}
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <SoftButton type="submit" color="dark" fullWidth>
                  Submit
                </SoftButton>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </DashboardLayout>
  );
}

export default Facilities;
